import * as React from 'react';
import { SVGProps } from 'react';

const IconFileArchiveSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3h6.5v1H12v1h-1.5v1H12v1h-1.5v1H12v1h-1.5v1H12v1h-1.5v1H12v1h-1.5v1H12v5H8v-5h1.5v-2H8v-1h1.5v-1H8V9h1.5V8H8V7h1.5V6H8V5h1.5V4H5v16h14V4h-6V3h7v18H4V3Zm5 12v3h2v-3H9Z"
    />
  </svg>
);
export default IconFileArchiveSizeM;
